import React, { useEffect, useState } from 'react';
import ReactCountryFlag from "react-country-flag";
import Select from 'react-select';
import { countries as allCountries } from 'countries-list';

const countries = Object.entries(allCountries)
    .map(([code, data]) => ({ value: code, label: data.name, flag: code }))
    .sort((a, b) => a.label.localeCompare(b.label));

const Paises = ({ darkMode, handleCountryChangeCallback, initialValue, menuPortalTarget }) => {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [postal, setPostal] = useState('');

    useEffect(() => {
        if (initialValue) {
            const found = countries.find(c => c.value === initialValue);
            if (found) setSelectedCountry(found);
            return;
        }
        const detectLocation = async () => {
            try {
                const response = await fetch('https://api.ipgeolocation.io/ipgeo?apiKey=4dd5108036e74396ac71b760775b0f39');
                const data = await response.json();
                const countryOption = countries.find(c => c.label === data.country_name);
                if (countryOption && data.zipcode) {
                    setPostal(data.zipcode);
                    handleCountryChange(countryOption, data.zipcode);
                }
            } catch (error) {
                console.error('Error detecting location:', error);
            }
        };
        detectLocation();
    }, [initialValue]);

    const handleCountryChange = (selectedOption, zip) => {
        const updatedOption = { ...selectedOption, postal: zip ?? postal };
        handleCountryChangeCallback(updatedOption);
        setSelectedCountry(selectedOption);
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: darkMode ? '#4b5563' : '#ffffff',
            borderColor: 'transparent',
            boxShadow: 'none',
            '&:hover': { borderColor: 'transparent' },
            width: '100%',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: darkMode ? '#374151' : '#ffffff',
            border: '1px solid',
            borderColor: darkMode ? '#4b5563' : '#e5e7eb',
            color: darkMode ? '#ffffff' : '#000000',
            marginTop: 0,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? (darkMode ? '#4b5563' : '#f3f4f6')
                : state.isFocused
                    ? (darkMode ? '#4b5563' : '#f3f4f6')
                    : (darkMode ? '#374151' : '#ffffff'),
            color: darkMode ? '#ffffff' : '#000000',
            padding: '8px 12px',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: darkMode ? '#ffffff' : '#000000',
        }),
        input: (provided) => ({
            ...provided,
            color: darkMode ? '#ffffff' : '#000000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: darkMode ? '#9ca3af' : '#6b7280',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <Select
            value={selectedCountry}
            onChange={(opt) => handleCountryChange(opt, postal)}
            options={countries}
            getOptionLabel={(option) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ReactCountryFlag countryCode={option.flag} svg style={{ marginRight: '8px', width: '1.2em', height: '1.2em' }} />
                    {option.label}
                </div>
            )}
            getOptionValue={(option) => option.value}
            styles={customStyles}
            placeholder="Select your nationality"
            isSearchable
            isClearable
            menuPortalTarget={menuPortalTarget ?? null}
            menuPosition={menuPortalTarget ? 'fixed' : 'absolute'}
        />
    );
};

export default Paises;
